module.exports = __webpack_public_path__ + "media/images/icon_ext_link_blue-b9a2eb24a4083c78be747e062a34e4d8.svg";